import {
  ALL_LOCALES,
  NORMAL_LOCALES,
  appPath,
  isLocal,
  DEFAULT_LOCALE,
} from '@web3/base-utils';
import { getSeoFormatLang, genPath } from './utils';

interface Props {
  title: string;
  keywords: string;
  description: string;
  locale: string;
  imgSrc?: string;
  tabIconSrc?: string;
}

export const MetaAndLink = (props: Props) => {
  const { title, keywords, description, imgSrc, tabIconSrc, locale } = props;

  const img = imgSrc || '/web3/static/logo.png';
  const metaList = [
    {
      name: 'description',
      content: description || title,
    },
    {
      name: 'keywords',
      content: keywords || title,
    },
    {
      property: 'og:type',
      content: 'website',
    },
    {
      property: 'og:title',
      content: title,
    },
    {
      property: 'og:description',
      content: description || title,
    },
    {
      property: 'og:url',
      content: genPath(locale, appPath),
    },
    {
      hid: 'og:locale',
      property: 'og:locale',
      content: locale,
    },
    {
      property: 'twitter:title',
      content: title,
    },
    {
      property: 'twitter:description',
      content: description || title,
    },
    {
      name: 'yandex-verification',
      content: '562817e58c38d16a',
    },
    {
      name: 'google-site-verification',
      content: 'cimlT5XFEqGBsSVh8XQe9sP-l8Z0mZ6UpeYSt612aHw',
    },
    {
      name: 'naver-site-verification',
      content: '520acf3890720b693406a160ba60807d6c9741c1',
    },
    {
      property: 'og:image',
      content: img,
    },
    {
      property: 'twitter:image',
      content: img,
    },
    {
      name: 'image',
      content: img,
    },
    {
      property: 'twitter:card',
      content: 'summary_large_image',
    },
  ];

  metaList.push(
    ...ALL_LOCALES.map((item) => item.value).map((lang) => {
      return {
        hid: `og:locale:alternate-${getSeoFormatLang(lang)}`,
        property: 'og:locale:alternate',
        content: getSeoFormatLang(lang).replace(/-/g, '_'),
      };
    })
  );

  const linkList = [
    {
      hid: `canonical-lang-${locale}`,
      rel: 'canonical',
      // We don't want testnet site on google rank, point to production link
      href: genPath(locale, appPath),
    },
    {
      hid: 'alternate-hreflang-x-default',
      rel: 'alternate',
      href: genPath(DEFAULT_LOCALE, appPath),
      hrefLang: 'x-default',
    },
  ];

  linkList.push(
    ...NORMAL_LOCALES.map((item) => item.value).map((lang) => {
      return {
        hid: `alternate-hreflang-${getSeoFormatLang(lang)}`,
        rel: 'alternate',
        href: genPath(locale, appPath, lang),
        hrefLang: getSeoFormatLang(lang),
      };
    })
  );

  return (
    <>
      <title>{title}</title>
      {/* 页面标签图片 */}
      {!isLocal && (
        <link
          rel="icon"
          href={tabIconSrc || '/common-static/fhs/bybit-home-new/favicon.ico'}
        />
      )}
      {/* 加速自定义字体的下载 */}
      {!isLocal && (
        <link
          rel="preload"
          as="font"
          type="font/woff2"
          crossOrigin="anonymous"
          href={`/common-static/fhs/IBMPlexSans-Regular-ba21ef1a37ee6d15eef777aedf368543.woff2`}
        />
      )}
      {!isLocal && (
        <link
          rel="preload"
          as="font"
          type="font/woff2"
          crossOrigin="anonymous"
          href={`/common-static/fhs/IBMPlexSans-Medium-64bcd7ec4d98272dc80e04b6d3bf8268.woff2`}
        />
      )}
      {!isLocal && (
        <link
          rel="preload"
          as="font"
          type="font/woff2"
          crossOrigin="anonymous"
          href={`/common-static/fhs/IBMPlexSans-SemiBold-6aca88931d6e2e67452aa4ac5f61f29d.woff2`}
        />
      )}
      {metaList.map((m, index) => (
        <meta key={index} {...m} />
      ))}
      {linkList.map((l, index) => (
        <link key={index} {...l} />
      ))}
    </>
  );
};
